import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import PageContainer from "~/components/PageContainer";
import { FullGridContext } from "../..";
import PagePreview from "./Preview";
import { getData } from "~/functions/gridFunctions";
import api from "~/services/api";

export const JobDescriptionContext = createContext();

export default function JobDescription() {
  const [departments, setDepartments] = useState([]);

  const defaultGridHeader = [
    {
      title: "Name",
      name: "name",
      type: "text",
      filter: true,
    },
    {
      title: "Description",
      name: "description",
      type: "text",
      filter: true,
    },
    {
      title: "Department",
      name: "department",
      type: "text",
      filter: true,
    },
  ];

  const {
    accessModule,
    setActiveFilters,
    limit,
    setGridData,
    setGridDetails,
    setGridHeader,
    setLoadingData,
    setPages,
    orderBy,
    search,
    page,
    opened,
  } = useContext(FullGridContext);

  const defaultOrderBy = { column: "name", asc: true };

  const pageAccess = accessModule.children.find(
    (el) => el.alias === "hr-jobdescription"
  );

  useEffect(() => {
    setActiveFilters([]);
  }, []);

  useEffect(() => {
    setGridHeader(defaultGridHeader);
  }, []);

  async function loadDepartments() {
    try {
      const { data } = await api.get(
        `/departments?limit=999&page=1&orderBy=name&orderASC=ASC`
      );
      setDepartments(data.rows || []);
    } catch (err) {
     
    }
  }

  async function loader() {
    setLoadingData(true);
    const data = await getData("jobdescriptions", {
      limit,
      page,
      orderBy,
      setPages,
      setGridData,
      search,
      defaultGridHeader,
      defaultOrderBy,
      setGridDetails,
    });

    if (!data) {
      setGridData([]);
      setLoadingData(false);
      return;
    }

    const gridDataValues = data.map(
      (
        { id, name, description, department, canceled_at },
        index
      ) => {
        return {
          show: true,
          id,
          fields: [name, description, department?.name || ""],
          canceled: canceled_at,
          page: Math.ceil((index + 1) / limit),
        };
      }
    );

    setGridData(gridDataValues);
    setLoadingData(false);
  }

  useEffect(() => {
    loader();
  }, [opened, orderBy, search, limit, page]);

  useEffect(() => {
    loadDepartments();
  }, []);

  const providerValue = useMemo(
    () => ({ departments }),
    [departments]
  );

  return (
    <JobDescriptionContext.Provider value={providerValue}>
      <PageContainer
        FullGridContext={FullGridContext}
        PagePreview={PagePreview}
        pageAccess={pageAccess}
        defaultGridHeader={defaultGridHeader}
      />
    </JobDescriptionContext.Provider>
  );
}
